module.exports = __webpack_public_path__ + "static/media/betyphon-integration-with-wordpress.98622b83.zip";